import React from 'react';

function CustomButton({ onClick, children, disabled, className, btnColor }) {
  return (
    <button
      type='button'
      className={`btn active pointer_class ${className || ''} ${
        btnColor ? `btn-${btnColor}` : 'btn-primary'
      }`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default CustomButton;



// WEBPACK FOOTER //
// ./src/views/ESG/Button/CustomButton.jsx